import React from 'react'
import { TableRow, TableCell, CircularProgress } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { CoreButton } from 'src/components/core'
import { withStyles } from '@material-ui/core'
import styles from './styles'
const RootTableCellButton = styled(TableCell)(() => ({
  backgroundColor: '#fff',
  textAlign: 'center',
  borderBottom: 'none',
}))

const BottomUpgradeButtons = props => {
  const { plans, handleClick, classes, category, loading } = props
  const filteredPlans = plans.filter(item => !item.isAllPlansInclude)
  return (
    <TableRow>
      <RootTableCellButton className={classes.cellWide}></RootTableCellButton>
      {filteredPlans.map((item, index) => (
        <RootTableCellButton key={item.subscription}>
          <CoreButton
            fullWidth
            size="large"
            color={
              (item.upgradeAction || item.action).active === true
                ? 'secondary'
                : 'primary'
            }
            variant={
              (item.upgradeAction || item.action).active === true
                ? 'text'
                : 'contained'
            }
            className={
              category.visible === true ? classes.visible : classes.hidden
            }
            disabled={
              (item.upgradeAction || item.action).disabled === true || loading
            }
            onClick={() => handleClick(item)}
          >
            {loading &&
            (item.upgradeAction || item.action).disabled !== true ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              (item.upgradeAction || item.action).tableText ||
              (item.upgradeAction || item.action).text
            )}
          </CoreButton>
        </RootTableCellButton>
      ))}
    </TableRow>
  )
}

export default withStyles(styles)(BottomUpgradeButtons)
